module.exports = __webpack_public_path__ + "img/104.ba81aa7e.jpg";